<div class="form-group">
  <label [title]="titleText">Format / Variant / Version @if (!searchObject?.distributionObjectId) {
    <span>[Document type]</span>
  }</label>
  <select class="form-control" [(ngModel)]="selectedDocumentType" (ngModelChange)="documentTypeChanged($event)">
    @if (showAllOption) {
      <option [ngValue]="null">{{showAllOptionText}}</option>
    }
    @for (docType of documentTypes; track docType) {
      <option [ngValue]="docType">{{docType.DisplayName}}</option>
    }
  </select>
</div>
